export default "<p>Authenticating...</p>\r\n";